import { API_BASE_URL } from './constants'

const TIMEOUT_MS = 20000

const httpClient = {
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' }
}

async function request(caminho: string, opcoes: RequestInit): Promise<Response> {
  const controlador = new AbortController()
  const temporizador = setTimeout(() => controlador.abort(), TIMEOUT_MS)

  try {
    const response = await fetch(`${httpClient.baseURL}${caminho}`, { ...opcoes, signal: controlador.signal, credentials: 'include' })
    if (!response.ok) throw new Error(`Pedido falhou: ${response.status}`)
    return response
  } catch (erro) {
    if (erro instanceof DOMException && erro.name === 'AbortError') {
      throw new Error('O servidor demorou demasiado tempo a responder. Tente novamente.')
    }
    throw erro
  } finally {
    clearTimeout(temporizador)
  }
}

export async function postJson<T>(caminho: string, corpo?: unknown): Promise<T> {
  const response = await request(caminho, {
    method: 'POST',
    headers: httpClient.headers,
    body: corpo !== undefined ? JSON.stringify(corpo) : undefined
  })

  const texto = await response.text()
  return texto ? JSON.parse(texto) : (null as T)
}

export async function postForm<T>(caminho: string, campos: Record<string, string>): Promise<T> {
  const response = await request(caminho, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
    body: new URLSearchParams(campos)
  })

  return response.json()
}

export default httpClient
